// RTK Slice action types - format: sliceName/actionName
export const LOGIN = "auth/login";
export const LOGOUT = "auth/logout";
export const UPDATE_PASSWORD_RESET_STATUS = "auth/updatePasswordResetStatus";
export const UPDATE_PROVIDER_CONNECTION = "auth/updateProviderConnection";

export const ADD_NOTIFICATION = "notification/addNotification";
export const REMOVE_NOTIFICATION = "notification/removeNotification";

export const SET_ACCOUNTS = "account/setAccounts";
export const ADD_ACCOUNT = "account/addAccount";
export const DELETE_ACCOUNT = "account/deleteAccount";
export const UPDATE_ACCOUNT = "account/updateAccount";

export const SET_FACILITIES = "facility/setFacilities";
export const ADD_FACILITY = "facility/addFacility";
export const UPDATE_FACILITY = "facility/updateFacility";
export const DELETE_FACILITY = "facility/deleteFacility";
export const GET_ACTIVE_FACILITIES = "activeFacilities/setActiveFacilities";

export const SET_PERMISSIONS = "permission/setUserPermissions";


export const REPORT_META_PATHS = ["title", "type", "filters.relation", "filters.type", "filters.selectedCardItem", "filters.isTotalCard", "filters.question", "filters.cardTitle", "filters.defaultTab", "filters.facilityId", "filters.facilityIds", "filters.lockedTotal"];
